/* tslint:disable */
/* eslint-disable */
export enum ColumnType {
  Numerical = 1,
  Dropdown = 2,
  Text = 3
}
